import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import Image from 'next/image';
import { benefitList, relatedServices } from '../constants/delivery';
import styles from '../styles/deliveryService.module.scss';
import DeliveryService from '../public/delivery.svg';
import Modal from '../components/contactUsModal';
import RelatedServices from '../components/relatedServices';
import Slider from '../components/slider/slider'
import PossibilitiesTabs from '../components/possibilitiesTabs';

const sliderImages = {
  en: {
    img1: '/services/delivery/img_en1.webp',
    img2: '/services/delivery/img_en2.webp',
  },
  ru: {
    img1: '/services/delivery/img_ru1.webp',
    img2: '/services/delivery/img_ru2.webp',
  }
};

export default function Delivery() {
  const router = useRouter();
  const { t } = useTranslation('serviceDelivery');

  const dataSlider = [
    <Image key={0} src={sliderImages[router.locale].img1} style={{ width: '100%' }} alt={t("sliderImageAlt")} loading='lazy' width={1350} height={733} unoptimized />,
    <Image key={1} src={sliderImages[router.locale].img2} style={{ width: '100%' }} alt={t("sliderImageAlt")} loading='lazy' width={1350} height={733} unoptimized />
  ]

  return (
    <Layout title={t('metaTitle')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection
        title='Service Delivery'
        description='deliveryDescription'
        documentationLink='https://help.icdc.io/admin/'
        customServiceName='Delivery'
        lang={router.locale}
      />

      <div className={styles.service} >
        <section className={styles.whatIsIt}>
          <div className={styles.serviceImg}>
            <Image src={DeliveryService} alt="Delivery Service" loading='lazy' />
          </div>
          <h2>{t('whatIsService.title')}</h2>
          <p dangerouslySetInnerHTML={{ __html: t('whatIsService.description', { interpolation: { escapeValue: false } }) }} />
        </section>

        <section className={styles.features}>
          <h2>{t('features.title')}</h2>
          <div className={styles.features__grid}>
            {new Array(4).fill('').map((_, index) => (
              <div key={index} className={styles.features__item}>
                <h3>{t(`features.title${index + 1}`)}</h3>
                <p>{t(`features.description${index + 1}`)}</p>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.slider}>
          <h2>{t('features.titleSlider')}</h2>
          <Slider dataSlider={dataSlider} />
        </section>

        <section className={styles.benefits}>
          <div className={styles.benefitsWrapper}>
            <h2>{t('cases.title')}</h2>
            {benefitList.map((item, index) => (
              <div key={index} className={styles.benefitsItem}>
                <Image src={item.img} alt="" />
                <h3>{t(item.subtitle)}</h3>
                <p>{t(item.subdescription)}</p>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.using}>
          <h2>{t('useService.title')}</h2>
          <p dangerouslySetInnerHTML={{ __html: t('useService.description', { interpolation: { escapeValue: false } }) }} />
        </section>

        <PossibilitiesTabs dictionary={"serviceDelivery"} tabsQuantity={6}/>

        <section className={styles.questions}>
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.desc')}</p>
          <Modal lang={router.locale} blue />
        </section>

        <section>
          <RelatedServices services={relatedServices} />
        </section>
      </div>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['serviceDelivery', 'common']),
  },
});
